import type { SurfaceEngineDefinition } from './SearchDefinitionContext';

export type ContextMethods = ReturnType<
  SurfaceEngineDefinition['controllers']['useContext']
>['methods'];

/**
 * The ranking-mode contexts are boolean pipeline conditions at runtime, but
 * Coveo types a context value as `string | string[]`, so the client-side cast
 * is centralized here. The server seed in SearchSsrPage writes the plain
 * context object before any controller exists, so it carries its own cast.
 */
export const addBooleanContext = (
  contextMethods: ContextMethods,
  key: string,
  value: boolean
) =>
  // @ts-expect-error boolean context value — see note above.
  contextMethods?.add(key, value);
